const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: "https://blackout.restaurant",
  title: "BLACKOUT.",
};

const about = {
  // all the properties are optional - can be left empty or deleted
  name: "BLACKOUT.Restaurant",
  role: "Dining in the Dark",
  description:
    "Let your senses take over and enjoy a unique dining experience. BLACKOUT is a concept restaurant in Trondheim, designed to activate your senses and let your primal instincts take over.",
  resume: "https://example.com",
  social: {
    linkedin: "https://linkedin.com",
    github: "https://github.com",
  },
};

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up

  //Text suggestion: Our menu is based on the best local produce in Trondheim, and our wine list is carefully selected to complement the food.
  {
    name: "Meat",
    description:
      "Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam",
    stack: ["SASS", "TypeScript", "React"],
    sourceCode: "https://github.com",
    livePreview: "https://github.com",
  },
  {
    name: "Fish",
    description:
      "Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam",
    stack: ["SASS", "TypeScript", "React"],
    sourceCode: "https://github.com",
    livePreview: "https://github.com",
  },
  {
    name: "Vegetarian",
    description:
      "Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam",
    stack: ["SASS", "TypeScript", "React"],
    sourceCode: "https://github.com",
    livePreview: "https://github.com",
  },
];

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  "HTML",
  "CSS",
  "JavaScript",
  "TypeScript",
  "React",
  "Redux",
  "SASS",
  "Material UI",
  "Git",
  "CI/CD",
  "Jest",
  "Enzyme",
];

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: "contact@blackout.restaurant",
};

export { header, about, projects, skills, contact };
